<template>
  <div ref="dialog_layer" v-show="dialog_visible>0" tabindex="-1" :class="['grcdialog2-layer']" 
        v-bind:style="{'left': layer_left, 'top': layer_top, 'min-width':layer_width+'px', 'min-height':layer_height+'px', 'width':'100%', 'height':'100%' }"
        @keydown="DialogKeydown"
  >
                    <div :class="['grcdialog2-cont']" 
                    v-bind:style="{'width':cont_width+'px', 'height':cont_height+'px', 'top':dialog_top+'px', 'left':dialog_left+'px' }"
                    >
                        <div ref="title" :class="['grcdialog2-title']"  
                         v-html="title"
                         @mousedown="onTitleMouseDown"
                         >
                        </div>

                        <transition name="tran_dlg_text"
                        v-on:before-enter="dlg_text_beforeEnter" v-on:enter="dlg_text_enter"
                        v-on:before-leave="dlg_text_beforeLeave" v-on:leave="dlg_text_leave">

                            <div ref="contenttext" class="grcdialog2-text" v-bind:style="{'max-height':contenttext_maxheight+'px'}" v-html="text" v-show="dialog_visible>0" />
                        </transition>

                        <div ref="buttoncont" class="grcdialog2-button-cont">
                          <GrcButton v-for="(btn, index) in buttons" ref="btn"
                          v-bind:grc_text=btn.text @grc-click="ButtonClick(index)" grc_readonly="false" 
                          v-bind:grc_style=btn.style
                          v-bind:grc_width=btn.width
                          @grc-keydown="ButtonPress($event,index)"
                          v-bind:key="index"
                          style="margin:5px 0px 5px 5px;" />                    

                        </div>
                    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import GrcButton from '../GrcComponents/GrcButton.vue'

export default {
  name: 'GrcDialog2',
  components:
  {
    GrcButton
  },
  props: {
  },
  data () {
    return {
        layer_left:0,
        layer_top:0,
        layer_width:300,
        layer_height:250,
        dialog_visible: 0,
        cont_width:0,
        cont_height:0,
        title:"",
        text:"",
        dialog_top:0,
        dialog_left:0,

        default_padding_top: 100,
        default_cont_width:300,
        default_cont_height: 250,
        
        buttons:[],
        button_focus_index:-1,

        move_mouse_startX:-1,
        move_mouse_startY:-1,
        move_dialog_startX:-1,
        move_dialog_startY:-1,

        contenttext_maxheight:0,


        PromiseResultObject: null
    }
  },
  watch : {
  },

  created: function()
  {
  },
  computed: {
  },
  updated: function() {

    this.$nextTick(function () {
      if (this.dialog_visible == 1)
      {
        this.dialog_visible = 2;

        this.button_focus_index = -1;
        for(var i=0;i<this.buttons.length;i++)
        {
          if (this.buttons[i].default == true) { this.button_focus_index = i; }
        }
        this.FocusButton();
      }
    });
  },

  mounted: function () {
    document.addEventListener('mousemove',  this.MouseMove);
    document.addEventListener('mouseup',  this.MouseUp);
  },

  destroyed: function()
  {
    document.removeEventListener('mousemove',  this.MouseMove);
    document.removeEventListener('mouseup',  this.MouseUp);
  },


  methods: {

    dlg_text_beforeEnter: function(el) 
    {
        this.cont_height = '0';
        this.contenttext_maxheight = 100000;
    },
    dlg_text_enter: function(el) 
    {
      /*
      console.log("dlg_text_enter "+el.scrollHeight);
      console.log("buttoncont: "+this.$refs.buttoncont.clientHeight);
      console.log("title: "+this.$refs.title.clientHeight);
      */

      let h = el.scrollHeight + this.$refs.buttoncont.clientHeight + this.$refs.title.clientHeight;
      h = h + 2; // border a fejléc és lábléc div-eknek

      if ((this.layer_height-90)<h)
      {
        h = this.layer_height-90;
      }

      this.contenttext_maxheight = h - this.$refs.buttoncont.clientHeight - this.$refs.title.clientHeight - 2;
      
      this.cont_height = h;

      let dt = (this.layer_height - this.cont_height) / 2;
      if (dt > 20) { dt = dt / 2; }
      this.dialog_top = dt;

    },
    dlg_text_beforeLeave: function(el) 
    {
      let h = el.scrollHeight + this.$refs.buttoncont.clientHeight + this.$refs.title.clientHeight + 2;
      this.cont_height = h;

    },
    dlg_text_leave: function(el)
    {
      this.cont_height = '0';
    },      


    onTitleMouseDown(e)
    {
      this.move_mouse_startX = e.pageX;
      this.move_mouse_startY = e.pageY;
      this.move_dialog_startX = this.dialog_left;
      this.move_dialog_startY = this.dialog_top;
    },

    MouseMove(e)
    {
      if (this.move_mouse_startX < 0) { return; }

      this.dialog_left = this.move_dialog_startX + (e.pageX - this.move_mouse_startX);
      this.dialog_top = this.move_dialog_startY + (e.pageY - this.move_mouse_startY);
    },

    MouseUp(e)
    {
      this.move_mouse_startX = -1;
    },


    ShowDialog(pParams)
    {
        this.$emit("popupopened");

        grcmain_SetBodyScrollable(false);

        var title = pParams.title;
        var text = pParams.text;
        var width = pParams.width;
        var height = 100;

        if (title == undefined) { title = ""; }
        if (text == undefined) { text = ""; }
        if (width == undefined) { width = this.default_cont_width; }

        for(var i=0; i<pParams.buttons.length; i++)
        {
            pParams.buttons[i].ref = "btn"+i;
        }

        this.buttons = pParams.buttons;

        //var bs = grccomp_getBodySize();
        var bs = grccomp_getScreenSize();

        this.layer_width = bs.width;
        this.layer_height = bs.height;

        if (width > bs.width) { width = bs.width - 10; }

        var left = (bs.width - width) / 2;
        var top = 10;


        this.title = title;
        this.cont_width = width;
        this.cont_height = height;
        this.dialog_top = top;
        this.dialog_left = left;
        this.text = text;


        
        this.dialog_visible = 1;

        return new Promise((resolve, reject) => {
          this.PromiseResultObject = resolve;
        });
    },

    Alert(pTitle, pText)
    {
      var params = grccomp_dialog_alert_GetDefaults(pTitle, pText);
      return this.ShowDialog(params);
    },

    Confirm(pTitle, pText)
    {
      var params = grccomp_dialog_yesno_GetDefaults(pTitle, pText);
      return this.ShowDialog(params);
    },



    DialogKeydown(e)
    {
      e.preventDefault();
      e.stopPropagation();
    },

    ButtonClick(pButtonIndex)
    {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = this.buttons[pButtonIndex].value;

        this.PromiseResultObject(res);
    },

    CloseDropdown()
    {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = "ESC";
        this.PromiseResultObject(res);
    },

    ButtonPress(pKeyCode, pIndex)
    {
      if (pKeyCode == 39)
      {
          if (this.button_focus_index >= 0)
          {
            var i = this.button_focus_index + 1;
            if (i>this.buttons.length-1) { i = 0; }
            this.button_focus_index = i;
            this.FocusButton();
          }

          return;
      }

      if (pKeyCode == 37)
      {
          if (this.button_focus_index >= 0)
          {
            var i = this.button_focus_index - 1;
            if (i<0) { i = this.buttons.length-1; }
            this.button_focus_index = i;
            this.FocusButton();
          }

          return;
      }

      if (pKeyCode == 27)
      {
        grcmain_SetBodyScrollable(true);
        this.$emit("popupclosed");
        this.dialog_visible = -1;
        var res = "ESC";

        this.PromiseResultObject(res);
        return;
      }


      //console.log(pKeyCode+" "+pIndex);
    },

    FocusButton()
    {
        if (this.button_focus_index >= 0)
        {
          this.$refs.btn[this.button_focus_index].SetFocus();
        }
        else
        {
          this.$refs.dialog_layer.focus();        
        }
    }

    
    
  }  // end: methods



}
</script>

